import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import { Typography } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  container: {
    margin: "5% auto 0  auto",
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
  control: {
    height: "200px",
  },
}));

export default function Download() {
  const classes = useStyles();

  return (
    <div
      className={classes.container}
      justify="center"
      style={{ maxWidth: "1100px" }}
    >
      <div className={classes.root}>
        <Typography
          style={{
            textAlign: "center",
            fontSize: "70px",
            margin: "0 auto 30px auto",
            fontWeight: "bold",
          }}
        >
          Download
        </Typography>
        <Grid
          item
          justify="center"
          container
          className={classes.root}
          spacing={2}
        >
          <Grid item xs={11} sm={6} style={{ textAlign: "center" }}>
            <div style={{ borderRadius: "50%" }}>
              <a href="https://play.google.com/store/apps/details?id=com.solotech.indiadocscanner">
                <img
                  src="image/play-store.png"
                  style={{ borderRadius: "40%" }}
                  alt="Play Store"
                  width="280px"
                  height="150px"
                  className="img-fluid"
                />
              </a>
            </div>
          </Grid>
          <Grid item xs={11} sm={6} style={{ textAlign: "center" }}>
            <div style={{ borderRadius: "50%" }}>
              <img
                src="image/qr-code.png"
                alt="PlayStore"
                width="150px"
                height="150px"
              />
            </div>
          </Grid>
        </Grid>
      </div>
    </div>
  );
}
